<template>
    <div class="flex-row vertical-center flow-wrap">
        <common-top-form :model="formModel" :show="false" :submitService="submitService"
                         :submitData="submitData" @success="onSuccess" >
            <el-form-item label="银行卡号">
                <el-input type="text" maxlength="50" v-model="formModel.cardNo" placeholder="请输入银行卡号"></el-input>
            </el-form-item>
            <el-form-item label="支付类型">
                <el-select v-model="formModel.payType">
                    <el-option
                        v-for="item in payTypes"
                        :key="item.dictKey"
                        :label="item.dictValue"
                        :value="item.dictKey">
                    </el-option>
                </el-select>
            </el-form-item>
        </common-top-form>
        <p class="account flex-1">账户余额：{{toDoubleThousands(amount)}}</p>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import TransactionService from 'service/TransactionService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "MPSearch",
        components: {
            CommonTopForm
        },
        data(){
            return{
                formModel:{
                    cardNo:'',
                    payType:'2',
                },
                amount:'',
                payTypes: [],
                submitService:TransactionService.selectBalence,
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted(){
            this.getTypeNames('payType', (res) => {
                this.payTypes = res;
            });
        },
        computed:{
            submitData(){
                const params = {
                    cardNo : this.formModel.cardNo.trim(),
                    payType : this.formModel.payType,
                    serverType: this.serverType,
                    tatId: this.tatId,
                    reqTime: new Date().format("yyyy-MM-dd HH:mm:ss")
                };
                params.sign = encrypt(urlEncode(objKeySort(params)) + '&priKey=' + privateKey.priKey);
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        watch:{
            'formModel.cardNo'(val,oldVal){
                this.amount = '0'
            },
        },
        methods:{
            onSuccess(data){
                if (data.contents.optStatus == '0000') {
                    this.amount = data.contents.optMsg
                } else {
                    this.showError(data.contents.optMsg)
                }
            },
        }
    }
</script>

<style scoped>
    .account{
        margin-bottom: 20px;
        padding-left: 30px;
    }

</style>



// WEBPACK FOOTER //
// src/view/fragment/TransactionManage/MPSearch.vue